export const careDefaultParameters = {
  "dailyPlan": [
    {
      "title": "Medications",
      "name": "medications",
      "enabled": false,
      "actions": [
        { id: 4054, title: 'Add SD Setup / Change', name: 'addSDSetup', enabled: false },
        { id: 4001, title: 'Add Medication', name: 'addMedication', enabled: false },
        { id: 4002, title: 'Add PRN medication', name: 'addPRNMedication', enabled: false },
        { id: 4019, title: 'Add Cream', name: 'addCream', enabled: false },
        { id: 4027, title: 'Add Insulin', name: 'addInsulin', enabled: false },
      ]
    },
    {
      "title": "Recurring Actions",
      "name": "recurringActions",
      "enabled": true,
      "actions": [
        {
          "title": "Personal Care",
          "name": "personalCare",
          "enabled": true,
          "actions": [
            { id: 8019, title: 'Catheter care', name: 'catheterCare', category: 'Personal care', enabled: false },
            { id: 8022, title: 'Menstruation', name: 'menstruation', category: 'Personal care', enabled: false },
          ]
        },
        {
          "title": "Toileting",
          "name": "toileting",
          "enabled": false,
          "actions": [
            { id: 1003, title: 'Toilet help', name: 'toiletHelp', enabled: false },
            { id: 1007, title: 'Bed pan', name: 'bedPan', enabled: false },
            { id: 1010, title: 'Urine bottle', name: 'urineBottle', enabled: false },
            { id: 1008, title: 'Commode', name: 'commode', enabled: false },
            { id: 9002, title: 'Pad check', name: 'padCheck', enabled: false },
            { id: 1009, title: 'Urinate', name: 'urinate', enabled: false },
            { id: 1001, title: 'Bowels opened', name: 'bowelsOpened', enabled: false },
            { id: 4017, title: 'Emptied', name: 'emptied', enabled: false },
            { id: 1006, title: 'Help with toilet', name: 'helpWithToilet', enabled: false },
            { id: 1099, title: 'Toileting-Other', name: 'toiletingOther', enabled: false }
          ]
        },
        {
          "title": "Medical",
          "name": "medical",
          "enabled": false,
          "actions": [
            { id: 4001, title: 'Medication', name: 'medication', enabled: false },
            { id: 4002, title: 'PRN Medication', name: 'prnMedication', enabled: false },
            { id: 4005, title: 'Doctor', name: 'doctor', enabled: false },
            { id: 4006, title: 'Nurse', name: 'nurse', enabled: false },
            { id: 4007, title: 'Qualified Specialist', name: 'specialist', enabled: false },
            { id: 4041, title: 'Professional', name: 'professional', enabled: false },
            { id: 2040, title: 'Massage', name: 'massage', enabled: false },
            { id: 4009, title: 'Dress wound', name: 'wound', enabled: false },
            { id: 4044, title: 'Heat pack', name: 'heatPack', enabled: false },
            { id: 4019, title: 'Cream', name: 'cream', enabled: false },
            { id: 4039, title: 'Foot splint', name: 'footSplint', enabled: false },
            { id: 4040, title: 'Hand splint', name: 'handSplint', enabled: false },
            { id: 4038, title: 'Compression garment', name: 'compression', enabled: false },
            { id: 4020, title: 'Skin', name: 'skinIntegrity', enabled: false },
            { id: 4047, title: 'Neuro Obs.', name: 'neuroObs', enabled: false },
            { id: 4022, title: 'Pulse', name: 'pulse', enabled: false },
            { id: 4042, title: 'Blood test', name: 'bloodTest', enabled: false },
            { id: 7016, title: 'Blood sugar', name: 'bloodSugar', enabled: false },
            { id: 4050, title: 'Soft signs', name: 'softSigns', enabled: false },
            { id: 4027, title: 'Insulin', name: 'insulin', enabled: false },
            { id: 4024, title: 'Temperature', name: 'temperature', enabled: false },
            { id: 4021, title: 'Blood pressure', name: 'bloodPressure', enabled: false },
            { id: 4025, title: 'Blood O2', name: 'bloodO2', enabled: false },
            { id: 4037, title: 'Blood INR', name: 'bloodINR', enabled: false },
            { id: 4023, title: 'Respiration', name: 'respiration', enabled: false },
            { id: 4049, title: 'Coronavirus', name: 'coronavirus', enabled: false },
            { id: 4049, title: 'Coronavirus symptom check', name: 'coronavirusSymptomCheck', enabled: false },
            { id: 4045, title: 'Consciousness', name: 'consciousness', enabled: false },
            { id: 4052, title: 'NEWS2', name: 'news2', enabled: false },
            { id: 4046, title: 'PainAssessment', name: 'inPain', enabled: false },
            { id: 4055, title: 'SD Check', name: 'sdCheck', enabled: false },
            { id: 4054, title: 'SD Setup / Change', name: 'sdSetupChange', enabled: false },
            { id: 4010, title: 'New catheter', name: 'newCatheter', enabled: false },
            { id: 4015, title: 'Bladder washout', name: 'washout', enabled: false },
            { id: 4016, title: 'Add catheter bag', name: 'addBag', enabled: false },
            { id: 4018, title: 'Change catheter bag', name: 'cleaned', enabled: false },
            { id: 4011, title: 'Gastrostomy Feed', name: 'peg', enabled: false },
            { id: 4012, title: 'Stoma', name: 'stoma', enabled: false },
            { id: 4030, title: 'Suction', name: 'suction', enabled: false },
            { id: 4029, title: 'Tracheostomy', name: 'tracheostomy', enabled: false },
            { id: 4013, title: 'Enema', name: 'enema', enabled: false },
            { id: 4033, title: 'IV line flush', name: 'ivLineFlush', enabled: false },
            { id: 4014, title: 'Sample', name: 'sample', enabled: false },
            { id: 4034, title: 'Multistix', name: 'multistix', enabled: false },
            { id: 4035, title: 'Ear syringe', name: 'earSyringe', enabled: false },
            { id: 4032, title: 'Clinic', name: 'clinic', enabled: false },
            { id: 4031, title: 'Hospital', name: 'hospital', enabled: false },
            { id: 4048, title: 'Therapeutic massage', name: 'therapeuticMassage', enabled: false },
            { id: 4043, title: 'PAP therapy', name: 'PAPTherapy', enabled: false },
            { id: 4051, title: 'Oxygen level', name: 'oxygenLevel', enabled: false },
            { id: 4099, title: 'Other', name: 'medicalOther', enabled: false }
          ]
        }
      ]
    }
  ],
  "dailyCare": [
    {
      "title": "Personal Care",
      "name": "personalCare",
      "enabled": true,
      "actions": [
        { id: 8019, title: 'Catheter care', name: 'catheterCare', category: 'Personal care', enabled: false },
        { id: 8022, title: 'Menstruation', name: 'menstruation', category: 'Personal care', enabled: false },
      ]
    },
    {
      "title": "Toileting",
      "name": "toileting",
      "enabled": false,
      "actions": [
        { id: 1003, title: 'Toilet help', name: 'toiletHelp', enabled: false },
        { id: 1007, title: 'Bed pan', name: 'bedPan', enabled: false },
        { id: 1010, title: 'Urine bottle', name: 'urineBottle', enabled: false },
        { id: 1008, title: 'Commode', name: 'commode', enabled: false },
        { id: 9002, title: 'Pad check', name: 'padCheck', enabled: false },
        { id: 1009, title: 'Urinate', name: 'urinate', enabled: false },
        { id: 1001, title: 'Bowels opened', name: 'bowelsOpened', enabled: false },
        { id: 4017, title: 'Emptied', name: 'emptied', enabled: false },
        { id: 1004, title: 'Wet clothes', name: 'wetClothes', enabled: false },
        { id: 1006, title: 'Help with toilet', name: 'helpWithToilet', enabled: false },
        { id: 1005, title: 'Soiled clothes', name: 'soiledClothes', enabled: false },
        { id: 1099, title: 'Toileting-Other', name: 'toiletingOther', enabled: false },
        { id: 1002, title: 'Loose bowels', name: 'looseBowels', enabled: false },
      ]
    },
    {
      "title": "Medical",
      "name": "medical",
      "enabled": false,
      "actions": [
        { id: 4001, title: 'Medication', name: 'medication', enabled: false },
        { id: 4042, title: 'Blood test', name: 'bloodTest', enabled: false },
        { id: 2040, title: 'Massage', name: 'massage', enabled: false },
        { id: 4051, title: 'Oxygen level', name: 'oxygenLevel', enabled: false },
        { id: 4099, title: 'Medical-Other', name: 'medicalOther', enabled: false },
        { id: 4002, title: 'PRN Medication', name: 'PRNMedication', enabled: false },
        { id: 4009, title: 'Wound', name: 'wound', enabled: false },
        { id: 4050, title: 'Soft signs', name: 'softSigns', enabled: false },
        { id: 4020, title: 'Skin integrity', name: 'skinIntegrity', enabled: false },
        { id: 4021, title: 'Blood pressure', name: 'bloodPressure', enabled: false },
        { id: 4035, title: 'Ear syringe', name: 'earSyringe', enabled: false },
        { id: 4041, title: 'Professional', name: 'professional', enabled: false },
        { id: 4044, title: 'Heat pack', name: 'heatPack', enabled: false },
        { id: 4018, title: 'Cleaned', name: 'cleaned', enabled: false },
        { id: 4023, title: 'Respiration', name: 'respiration', enabled: false },
        { id: 4025, title: 'Blood O2', name: 'bloodO2', enabled: false },
        { id: 4014, title: 'Sample', name: 'sample', enabled: false },
        { id: 4040, title: 'Hand splint', name: 'handSplint', enabled: false },
        { id: 4006, title: 'Nurse', name: 'nurse', enabled: false },
        { id: 4029, title: 'Tracheostomy', name: 'tracheostomy', enabled: false },
        { id: 4022, title: 'Pulse', name: 'pulse', enabled: false },
        { id: 4039, title: 'Foot splint', name: 'footSplint', enabled: false },
        { id: 4047, title: 'Neuro Obs', name: 'neuroObs', enabled: false },
        { id: 4016, title: 'Add bag', name: 'addBag', enabled: false },
        { id: 4011, title: 'Gastrostomy Feed', name: 'PEG', enabled: false },
        { id: 4036, title: 'In pain', name: 'inPain', enabled: false },
        { id: 4024, title: 'Temperature', name: 'temperature', enabled: false },
        { id: 7016, title: 'Blood sugar', name: 'bloodSugar', enabled: false },
        { id: 4033, title: 'IV line flush', name: 'IVLineFlush', enabled: false },
        { id: 4012, title: 'Stoma', name: 'stoma', enabled: false },
        { id: 4053, title: 'Choking Intervention', name: 'chokingIntervention', enabled: false },
        { id: 4038, title: 'Compression', name: 'compression', enabled: false },
        { id: 4032, title: 'Clinic', name: 'clinic', enabled: false },
        { id: 4034, title: 'Multistix', name: 'multistix', enabled: false },
        { id: 4013, title: 'Enema', name: 'enema', enabled: false },
        { id: 4055, title: 'SD Check', name: 'SDCheck', enabled: false },
        { id: 4004, title: 'Ambulance', name: 'ambulance', enabled: false },
        { id: 4005, title: 'Doctor', name: 'doctor', enabled: false },
        { id: 4030, title: 'Suction', name: 'suction', enabled: false },
        { id: 4019, title: 'Cream', name: 'cream', enabled: false },
        { id: 4008, title: 'Sick', name: 'sick', enabled: false },
        { id: 4015, title: 'Washout', name: 'washout', enabled: false },
        { id: 4045, title: 'Consciousness', name: 'consciousness', enabled: false },
        { id: 4054, title: 'SD Setup / Change', name: 'SDSetupChange', enabled: false },
        { id: 4010, title: 'New catheter', name: 'newCatheter', enabled: false },
        { id: 4028, title: 'Epileptic seizure', name: 'epilepticSeizure', enabled: false },
        { id: 4007, title: 'Qualified Specialist', name: 'specialist', enabled: false },
        { id: 4031, title: 'Hospital', name: 'hospital', enabled: false },
        { id: 4027, title: 'Insulin', name: 'insulin', enabled: false },
        { id: 4048, title: 'Therapeutic massage', name: 'therapeuticMassage', enabled: false },
        { id: 4049, title: 'Coronavirus', name: 'coronavirus', enabled: false },
        { id: 4046, title: 'Pain Assessment', name: 'Pain Assessment', enabled: false },
        { id: 4043, title: 'PAP therapy', name: 'papTherapy', enabled: false },
        { id: 4037, title: 'Blood INR', name: 'bloodINR', enabled: false },
        { id: 4052, title: 'NEWS2', name: 'NEWS2', enabled: false },
        { id: 4003, title: 'Call doctor', name: 'callDoctor', enabled: false }
      ]
    },
    {
      "title": "Sleeping",
      "name": "sleeping",
      "enabled": false,
      "actions": [
        { id: 9002, title: 'Check pad', name: 'checkPad', category: 'Sleeping', enabled: false },
      ]
    }
  ]
};
